module.exports = __webpack_public_path__ + "img/8e84281.png";